export const TICKETS_NEEDED_FOR_BONUS = 10;
